var exports = {
  "KA": "splitterV-eWZiR",
  "MS": "splitterH-eWZiR",
  "sW": "bordered-eWZiR",
  "cA": "reflexContainer-eWZiR",
};

module.exports = exports;
